import { createContext } from 'react';

export const MAX_TEXT_COMPONENT = 60;

export type ScrollDirection = 'up' | 'down';

export const ArticleContext = createContext<ArticleContextProps>({
	width: null,
	height: null,
	styles: new Map(),
	style: null,
	lang: 'en',
	isPrinting: false,
	onLightboxTargetClick: () => {},
	onEventSend: () => {},
	onLightboxClick: () => {},
});

export interface ArticleContextProps {
	width: any;
	height: any;
	styles: Map<string, any>;
	style: any; // string | number | null | any;
	isPrinting?: boolean;
	lang: any; // string | any;
	onLightboxTargetClick?: any;
	onEventSend?: any;
	onLightboxClick?: any;
}

export const CanvasContext = createContext<CanvasContextProps>({
	paddingLeft: null,
	paddingRight: null,
});

interface CanvasContextProps {
	paddingLeft?: string | number | null;
	paddingRight?: string | number | null;
}

export const ArticlesContext = createContext<ArticlesContext>({
	selectedIndex: null,
	lang: 'en',
	isTouchDevice: false,
	styles: new Map(),
});

interface ArticlesContext {
	selectedIndex: number | null;
	lang: string;
	setScrollDirection?: (direction: ScrollDirection) => void;
	isTouchDevice: boolean;
	styles: Map<string, any>;
}
